import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';

interface FormData {
  enderecoLocal: string;
  nomeContato: string;
  telefoneContato: string;
  emailContato: string;
  dataRecolha: string;
}

export default function InformacoesLocal() {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState<FormData>({
    enderecoLocal: '',
    nomeContato: '',
    telefoneContato: '',
    emailContato: '',
    dataRecolha: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    dispatch({
      type: 'dadosLocal',
      payload: { dadosLocal: formData }
    });
  }, [formData, dispatch]);

  return (
    <div className="tw-p-4 tw-bg-white tw-rounded-lg tw-shadow-sm">
      <Typography variant="h5" className="tw-mb-4 tw-font-semibold tw-text-gray-900">
        INFORMAÇÕES DO LOCAL DE RECOLHA
      </Typography>

      <div className="tw-grid tw-gap-4">
        {/* Primeira linha: Endereço do local (ocupa toda largura) */}
        <div>
          <TextField
            required
            type="text"
            label="Nome e endereço do lugar onde foi recolhido a amostra"
            fullWidth
            multiline
            rows={2}
            size="small"
            name="enderecoLocal"
            variant="outlined"
            onChange={handleChange}
            value={formData.enderecoLocal}
          />
        </div>

        {/* Subtítulo para informações de contato */}
        <div>
          <Typography variant="subtitle1" className="tw-mt-4 tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-700">
            Pessoa de contacto no local:
          </Typography>
        </div>

        {/* Segunda linha: Nome do contato (ocupa toda largura) */}
        <div>
          <TextField
            required
            type="text"
            label="Nome"
            fullWidth
            size="small"
            name="nomeContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.nomeContato}
          />
        </div>

        {/* Terceira linha: Telefone e Email (lado a lado) */}
        <div className="tw-grid tw-gap-4 md:tw-grid-cols-2">
          <TextField
            required
            type="tel"
            label="Nº Telefone"
            fullWidth
            size="small"
            name="telefoneContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.telefoneContato}
          />
          <TextField
            required
            type="email"
            label="Email"
            fullWidth
            size="small"
            name="emailContato"
            variant="outlined"
            onChange={handleChange}
            value={formData.emailContato}
          />
        </div>

        {/* Quarta linha: Data da recolha (ocupa metade da largura) */}
        <div className="md:tw-w-1/2">
          <TextField
            required
            type="date"
            label="Data da recolha"
            fullWidth
            size="small"
            name="dataRecolha"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onChange={handleChange}
            value={formData.dataRecolha}
          />
        </div>
      </div>
    </div>
  );
}